import $ from 'jquery'

let Catalogue = {
  Initalised : false,
  
}

Catalogue.init = function()
{
  if(!this.Initalised)
  {
    this.Initalised = true;
  }else{
    return false;
  }

  var CatalogueButton = document.getElementById('catalogue-button');
  var categories = document.getElementById('categories-dropdown');

  this.up = document.getElementById('up-arrow');
  this.down = document.getElementById('down-arrow');

  if(CatalogueButton){
    CatalogueButton.addEventListener('click', () => {
      if(categories.classList.contains('show')){
        categories.classList.remove('show');
        this.up.classList.remove('show');  
        this.down.classList.add('show');
      }else{
        categories.classList.add('show');  
        this.up.classList.add('show');  
        this.down.classList.remove('show');
      }
     
    });

  }

}

export default Catalogue;


// WEBPACK FOOTER //
// ./resources/assets/js/components/catalogue.js